<template>
  <div>
    <div class="d-flex justify-content-center align-items-center">
      <img
        class="img-fluid-branded-logo"
        :src="getImage(brandingConfig.logos.logo)"
        alt=""
        loading="lazy"
        :data-cy="`${branding}-login-logo`"
      />
    </div>

    <p class="text-center text-muted small my-4">
      {{ $t('login.login_sign_in.description') }}
    </p>
  </div>
</template>

<script>
import brandingMixin from 'src/mixins/branding/brandingMixin.js'

export default {
  name: 'LoginWelcomeTo',
  mixins: [brandingMixin],
}
</script>
